import { render, staticRenderFns } from "./SearchResults.vue?vue&type=template&id=5f894315&scoped=true&"
import script from "./SearchResults.vue?vue&type=script&lang=js&"
export * from "./SearchResults.vue?vue&type=script&lang=js&"
import style0 from "./search-results.css?vue&type=style&index=0&id=5f894315&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f894315",
  null
  
)

export default component.exports